import React from 'react'

import IFrame from 'components/IFrame'
import { images } from 'packages/simplesat-config'
import { embedScript } from '../GenerateEmbedCodeModal/utils'

/**
 * @param {object} props
 * @param {string} props.embedStyleType
 * @param {object} [props.language]
 * @param {string} props.surveyToken
 * @param {object} props.placeholders
 * @param {object} props.primaryQuestion
 * @param {string} props.currentSelectedIntegration
 * @param {import('components/GenerateEmbedCodeModal/utils').RatingIconDimension} [props.ratingIconDimension]
 * @param {import('components/GenerateEmbedCodeModal/utils').RatingIconDisplayOptions} props.ratingIconDisplayOptions
 * @param {number} [props.emailPreviewIframeHeight]
 * @param {import('../GenerateEmbedCodeModal/utils').CustomField} [props.customField]
 */
export const EmailPreview = ({
  embedStyleType,
  surveyToken,
  placeholders,
  primaryQuestion,
  ratingIconDimension,
  currentSelectedIntegration,
  ratingIconDisplayOptions,
  emailPreviewIframeHeight,
  customField,
}) => {
  const surveyConfig = { surveyToken, primaryQuestion, currentSelectedIntegration }
  const isPreview = true
  const htmlEmbedCode = embedScript(
    surveyConfig,
    placeholders,
    embedStyleType,
    ratingIconDisplayOptions,
    ratingIconDimension,
    customField,
    isPreview
  )
  return (
    <div className="ui segments">
      <div
        className="ui compact segment"
        style={{
          paddingTop: '.3em',
          paddingBottom: '.1em',
          backgroundColor: '#F8F8F8',
        }}
      >
        <div className="ui white basic empty circular label" />
        <div className="ui white basic empty circular label" />
        <div className="ui white basic empty circular label" />
      </div>
      <div className="ui segment">
        <img
          className="ui image"
          src={images.emailSkeleton}
          alt="email skeleton"
          style={{ height: '8.75rem' }}
        />
        <IFrame
          className="mt-4"
          style={{ pointerEvents: 'none' }}
          height={emailPreviewIframeHeight}
        >
          <div
            dangerouslySetInnerHTML={{
              __html: htmlEmbedCode,
            }}
          />
        </IFrame>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/EmailPreview/EmailPreview.js